/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ActivityLogDto } from '../models/activity-log-dto';
import { CommonId } from '../models/common-id';
import { SaasBillingMetadataDto } from '../models/saas-billing-metadata-dto';
import { SaasSubscriptionMetadataDto } from '../models/saas-subscription-metadata-dto';


/**
 * Processing of saas billing files to calculate the billing amount.
 */
@Injectable({
  providedIn: 'root',
})
export class SaasBillingService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation reviewOk
   */
  static readonly ReviewOkPath = '/api/v1/gmap-billing/review-ok';

  /**
   * Review GMap Billing Excel.
   *
   * The API to parse and save billing excel
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reviewOk()` instead.
   *
   * This method doesn't expect any request body.
   */
  reviewOk$Response(params: {
    id: string;
    month: number;
    year: number;
    comments?: string;
  }): Observable<StrictHttpResponse<Array<SaasBillingMetadataDto>>> {

    const rb = new RequestBuilder(this.rootUrl, SaasBillingService.ReviewOkPath, 'put');
    if (params) {
      rb.query('id', params.id, {});
      rb.query('month', params.month, {});
      rb.query('year', params.year, {});
      rb.query('comments', params.comments, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<SaasBillingMetadataDto>>;
      })
    );
  }

  /**
   * Review GMap Billing Excel.
   *
   * The API to parse and save billing excel
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reviewOk$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reviewOk(params: {
    id: string;
    month: number;
    year: number;
    comments?: string;
  }): Observable<Array<SaasBillingMetadataDto>> {

    return this.reviewOk$Response(params).pipe(
      map((r: StrictHttpResponse<Array<SaasBillingMetadataDto>>) => r.body as Array<SaasBillingMetadataDto>)
    );
  }

  /**
   * Path part for operation upload
   */
  static readonly UploadPath = '/api/v1/gmap-billing/upload';

  /**
   * Upload GMAP Billing Excel.
   *
   * The API to upload GMAP billing excel to storage Account
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `upload()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upload$Response(params: {
    saasId: string;
    comments?: string;
    month?: number;
    year?: number;
    body?: {
'file': Blob;
}
  }): Observable<StrictHttpResponse<SaasBillingMetadataDto>> {

    const rb = new RequestBuilder(this.rootUrl, SaasBillingService.UploadPath, 'post');
    if (params) {
      rb.query('saasId', params.saasId, {});
      rb.query('comments', params.comments, {});
      rb.query('month', params.month, {});
      rb.query('year', params.year, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SaasBillingMetadataDto>;
      })
    );
  }

  /**
   * Upload GMAP Billing Excel.
   *
   * The API to upload GMAP billing excel to storage Account
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `upload$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upload(params: {
    saasId: string;
    comments?: string;
    month?: number;
    year?: number;
    body?: {
'file': Blob;
}
  }): Observable<SaasBillingMetadataDto> {

    return this.upload$Response(params).pipe(
      map((r: StrictHttpResponse<SaasBillingMetadataDto>) => r.body as SaasBillingMetadataDto)
    );
  }

  /**
   * Path part for operation activateDeactivateSubscription1
   */
  static readonly ActivateDeactivateSubscription1Path = '/api/v1/saas/subscriptions/{subscriptionId}';

  /**
   * Subscription Status.
   *
   * The API Upates subscription Activate or Deactivate
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `activateDeactivateSubscription1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  activateDeactivateSubscription1$Response(params: {
    subscriptionId: string;
    body: CommonId
  }): Observable<StrictHttpResponse<CommonId>> {

    const rb = new RequestBuilder(this.rootUrl, SaasBillingService.ActivateDeactivateSubscription1Path, 'patch');
    if (params) {
      rb.path('subscriptionId', params.subscriptionId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CommonId>;
      })
    );
  }

  /**
   * Subscription Status.
   *
   * The API Upates subscription Activate or Deactivate
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `activateDeactivateSubscription1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  activateDeactivateSubscription1(params: {
    subscriptionId: string;
    body: CommonId
  }): Observable<CommonId> {

    return this.activateDeactivateSubscription1$Response(params).pipe(
      map((r: StrictHttpResponse<CommonId>) => r.body as CommonId)
    );
  }

  /**
   * Path part for operation gmapReviewNotOk
   */
  static readonly GmapReviewNotOkPath = '/api/v1/gmap-billing/review-not-ok';

  /**
   * Review Not Ok GMap Billing Excel.
   *
   * The API updates the status and delete G map billing excel
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `gmapReviewNotOk()` instead.
   *
   * This method doesn't expect any request body.
   */
  gmapReviewNotOk$Response(params: {
    saasId: string;
    month: number;
    year: number;
    comments: string;
  }): Observable<StrictHttpResponse<SaasBillingMetadataDto>> {

    const rb = new RequestBuilder(this.rootUrl, SaasBillingService.GmapReviewNotOkPath, 'patch');
    if (params) {
      rb.query('saasId', params.saasId, {});
      rb.query('month', params.month, {});
      rb.query('year', params.year, {});
      rb.query('comments', params.comments, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SaasBillingMetadataDto>;
      })
    );
  }

  /**
   * Review Not Ok GMap Billing Excel.
   *
   * The API updates the status and delete G map billing excel
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `gmapReviewNotOk$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  gmapReviewNotOk(params: {
    saasId: string;
    month: number;
    year: number;
    comments: string;
  }): Observable<SaasBillingMetadataDto> {

    return this.gmapReviewNotOk$Response(params).pipe(
      map((r: StrictHttpResponse<SaasBillingMetadataDto>) => r.body as SaasBillingMetadataDto)
    );
  }

  /**
   * Path part for operation gmapBillingStatusInReview
   */
  static readonly GmapBillingStatusInReviewPath = '/api/v1/gmap-billing/in-review/{gmapMetadataId}';

  /**
   * Review GMap Billing Excel.
   *
   * The API to change status of GMap billing excel
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `gmapBillingStatusInReview()` instead.
   *
   * This method doesn't expect any request body.
   */
  gmapBillingStatusInReview$Response(params: {
    gmapMetadataId: string;
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, SaasBillingService.GmapBillingStatusInReviewPath, 'patch');
    if (params) {
      rb.path('gmapMetadataId', params.gmapMetadataId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * Review GMap Billing Excel.
   *
   * The API to change status of GMap billing excel
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `gmapBillingStatusInReview$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  gmapBillingStatusInReview(params: {
    gmapMetadataId: string;
  }): Observable<string> {

    return this.gmapBillingStatusInReview$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation getAllSubscriptions
   */
  static readonly GetAllSubscriptionsPath = '/api/v1/saas/subscriptions';

  /**
   * Get Subscription List.
   *
   * The API to view the subscription list
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllSubscriptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSubscriptions$Response(params?: {
    month?: number;
    year?: number;
  }): Observable<StrictHttpResponse<Array<SaasSubscriptionMetadataDto>>> {

    const rb = new RequestBuilder(this.rootUrl, SaasBillingService.GetAllSubscriptionsPath, 'get');
    if (params) {
      rb.query('month', params.month, {});
      rb.query('year', params.year, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<SaasSubscriptionMetadataDto>>;
      })
    );
  }

  /**
   * Get Subscription List.
   *
   * The API to view the subscription list
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAllSubscriptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSubscriptions(params?: {
    month?: number;
    year?: number;
  }): Observable<Array<SaasSubscriptionMetadataDto>> {

    return this.getAllSubscriptions$Response(params).pipe(
      map((r: StrictHttpResponse<Array<SaasSubscriptionMetadataDto>>) => r.body as Array<SaasSubscriptionMetadataDto>)
    );
  }

  /**
   * Path part for operation getSubscriptionListByProfileId
   */
  static readonly GetSubscriptionListByProfileIdPath = '/api/v1/saas/profile/{profileId}';

  /**
   * Manage Subscription List.
   *
   * The API to view the subscription list
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubscriptionListByProfileId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionListByProfileId$Response(params: {
    profileId: string;
    month?: number;
    year?: number;
  }): Observable<StrictHttpResponse<Array<SaasSubscriptionMetadataDto>>> {

    const rb = new RequestBuilder(this.rootUrl, SaasBillingService.GetSubscriptionListByProfileIdPath, 'get');
    if (params) {
      rb.path('profileId', params.profileId, {});
      rb.query('month', params.month, {});
      rb.query('year', params.year, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<SaasSubscriptionMetadataDto>>;
      })
    );
  }

  /**
   * Manage Subscription List.
   *
   * The API to view the subscription list
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getSubscriptionListByProfileId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionListByProfileId(params: {
    profileId: string;
    month?: number;
    year?: number;
  }): Observable<Array<SaasSubscriptionMetadataDto>> {

    return this.getSubscriptionListByProfileId$Response(params).pipe(
      map((r: StrictHttpResponse<Array<SaasSubscriptionMetadataDto>>) => r.body as Array<SaasSubscriptionMetadataDto>)
    );
  }

  /**
   * Path part for operation getGmapActivityLogListByMetaDataId
   */
  static readonly GetGmapActivityLogListByMetaDataIdPath = '/api/v1/gmap-billing/activity-log/{gmapBillingMetadataId}';

  /**
   * Manage GMap Activity Log .
   *
   * The API to view the Gmap activity log
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getGmapActivityLogListByMetaDataId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGmapActivityLogListByMetaDataId$Response(params: {
    gmapBillingMetadataId: string;
  }): Observable<StrictHttpResponse<Array<ActivityLogDto>>> {

    const rb = new RequestBuilder(this.rootUrl, SaasBillingService.GetGmapActivityLogListByMetaDataIdPath, 'get');
    if (params) {
      rb.path('gmapBillingMetadataId', params.gmapBillingMetadataId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ActivityLogDto>>;
      })
    );
  }

  /**
   * Manage GMap Activity Log .
   *
   * The API to view the Gmap activity log
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getGmapActivityLogListByMetaDataId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGmapActivityLogListByMetaDataId(params: {
    gmapBillingMetadataId: string;
  }): Observable<Array<ActivityLogDto>> {

    return this.getGmapActivityLogListByMetaDataId$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ActivityLogDto>>) => r.body as Array<ActivityLogDto>)
    );
  }

}
